@if (isUpdating$ | async) {
  <cx-spinner class="overlay"></cx-spinner>
}

<div class="row">
  <div class="col-12">
    <h2 class="page-title">{{ 'updatePasswordForm.title' | cxTranslate }}</h2>
  </div>
</div>


<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <div class="row">
    <div class="col-md-12 col-lg-6">
      <label class="label-password">
        <span class="label-content">{{ 'updatePasswordForm.oldPassword.label' | cxTranslate }}</span>
        <input
          class="form-control"
          [type]="showPasswordOld ? 'text' : 'password'"
          name="oldPassword"
          placeholder="{{ 'updatePasswordForm.oldPassword.placeholder' | cxTranslate }}"
          formControlName="oldPassword"
          />
        <app-custom-icons (click)="isPasswordHiddenOld()" [type]="showPasswordOld ? iconTypes.EYE : iconTypes.EYE_SLASH"></app-custom-icons>
        <cx-form-errors [control]="form.get('oldPassword')"></cx-form-errors>
      </label>

      <label class="label-password">
        <span class="label-content">{{
          'updatePasswordForm.newPassword.label' | cxTranslate
        }}</span>
        <input
          class="form-control"
          [type]="showPassword ? 'text' : 'password'"
          name="newPassword"
      placeholder="{{
        'updatePasswordForm.newPassword.placeholder' | cxTranslate
      }}"
          formControlName="newPassword"
          />
        <app-custom-icons (click)="isPasswordHidden()" [type]="showPassword ? iconTypes.EYE : iconTypes.EYE_SLASH"></app-custom-icons>
        <cx-form-errors [control]="form.get('newPassword')"></cx-form-errors>
      </label>

      <label class="label-password">
        <span class="label-content">{{
          'updatePasswordForm.confirmPassword.label' | cxTranslate
        }}</span>
        <input
          class="form-control"
          [type]="showPasswordConfirm ? 'text' : 'password'"
          name="newPasswordConfirm"
      placeholder="{{
        'updatePasswordForm.confirmPassword.placeholder' | cxTranslate
      }}"
          formControlName="newPasswordConfirm"
          />
        <app-custom-icons (click)="isPasswordHiddenConfirm()" [type]="showPasswordConfirm ? iconTypes.EYE : iconTypes.EYE_SLASH"></app-custom-icons>
        <cx-form-errors [control]="form.get('newPasswordConfirm')"></cx-form-errors>
      </label>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-4 mt-4">
      <button class="btn btn-block btn-black" [disabled]="form.disabled">
        {{ 'common.change' | cxTranslate }}
      </button>
    </div>
  </div>
</form>

